import NotificationLogClient, { DEFAULT_SOURCE } from './NotificationLogClient';

export type { NotificationLogProvider, NotificationCountResponse } from './types';

export { NotificationLogClient, DEFAULT_SOURCE };
